import React from "react"
import { useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { ScoreTypeComponent } from "../../components/scoreType"

export const ScoreTypePage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <ScoreTypeComponent id={Number(id)} />
    </DefaultPageComp>
  </>
}